module.exports = __webpack_public_path__ + "static/media/icomoon.5a93ca37.eot";